export enum TemplateCodes {
  SLIDESHOW = '3440',
  VIDEO = '3441',
}
